export const initProductGalleries = (root = document) => {
  const galleries = root.querySelectorAll("[data-product-gallery]");

  galleries.forEach((gallery) => {
    if (gallery.dataset.galleryBound === "true") return;
    const images = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
    if (images.length <= 1) return;

    const setActive = (nextIndex) => {
      images.forEach((img, index) => {
        img.classList.toggle("opacity-100", index === nextIndex);
        img.classList.toggle("opacity-0", index !== nextIndex);
      });
      gallery.dataset.galleryIndex = String(nextIndex);
    };

    gallery.dataset.galleryIndex = "0";
    gallery.dataset.galleryBound = "true";
    gallery.addEventListener("click", () => {
      const currentIndex = parseInt(gallery.dataset.galleryIndex || "0", 10);
      const nextIndex = (currentIndex + 1) % images.length;
      setActive(nextIndex);
    });
  });
};

initProductGalleries();
